import { ColumnsEdit } from "types/models/column-table-edit";

export const columnsAddGroup: ColumnsEdit = [
  {
    title: "STT",
    dataIndex: "stt",
    width: "5%",
    render: (v, r, i) => i + 1,
  },
  {
    title: "Tên đoàn",
    dataIndex: "tenDoanKham",
    width: "35%",
  },
  {
    title: "Ghi chú",
    dataIndex: "ghiChu",
    width: "40%",
    align: "left",
  },
  {
    title: "Thao tác",
    dataIndex: "actions",
    width: "10%",
  },
];
